import axios from 'axios'
import { createI18n } from 'vue-i18n'
import dayjs from 'dayjs'

import zh_CN from './locales/zh-cn'
import zh_TW from './locales/zh-tw'

export { dayjs }

// Env
export const env = {
  viteAppEnv: import.meta.env.VITE_APP_ENV,
  viteBaseUrl: import.meta.env.VITE_BASE_URL,
  viteSiteName: import.meta.env.VITE_SITE_NAME,
  viteBuildCompress: import.meta.env.VITE_BUILD_COMPRESS,
  // @ts-ignore
  viteIsProd: import.meta.env.PROD === 'production',
}

// I18n 中文简繁体转换 https://tool.lu/zhconvert/
export const supportedLocales = {
  'zh-CN': 'CN',
  'zh-TW': '繁',
}

// 1. 尝试读取本地存储的语言
const storedLocale = localStorage.getItem('locale')
const localeKey =
  storedLocale && supportedLocales[storedLocale]
    ? storedLocale
    : // 2. 尝试使用浏览器语言并模糊匹配
      (Object.keys(supportedLocales).find(locale =>
        // @ts-ignore
        (navigator.language || navigator.userLanguage).toLowerCase().includes(locale.toLowerCase()),
      ) ??
      // 3. 使用默认语言
      'zh-CN')

const localeName = supportedLocales[localeKey]
export const i18n = createI18n({
  locale: localeKey,
  globalInjection: true,
  // fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zh_CN,
    'zh-TW': zh_TW,
    // 'en': en
  },
})
export { localeKey, localeName }
export const t = i18n.global.t
export const setLocale = locale => {
  if (!supportedLocales[locale]) return
  localStorage.setItem('locale', locale)
  i18n.global.locale = locale
  // 可选:如果需要刷新页面
  window.location.reload()
}

// Apis
const defaultConfig = {
  // timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
}
const createInstance = config => {
  const instance = axios.create({
    ...defaultConfig,
    ...config,
  })
  // 请求拦截器
  instance.interceptors.request.use(
    config => {
      // const token = localStorage.getItem('token')
      // if (token) {
      //   config.headers.Authorization = `Bearer ${token}`
      // }
      return config
    },
    error => Promise.reject(error),
  )
  instance.interceptors.response.use(
    // response => response.data,
    response => response,
    error => Promise.reject(error),
  )
  return instance
}

export const baseHttp = createInstance()
const bizHttp = createInstance({
  baseURL: env.viteBaseUrl,
})
// 导出请求方法
export const http = {
  pages: params => bizHttp.request({ url: '/data/pages', method: 'GET', params }),
  get: (url, params) => baseHttp.get(url, { params }),
  post: (url, data) => baseHttp.post(url, data),
  put: (url, data) => baseHttp.put(url, data),
  delete: (url, params) => baseHttp.delete(url, { params }),
}

// Store
export const store = {
  useCounterStore: defineStore('counter', () => {
    const count = ref(0)
    const doubleCount = computed(() => count.value * 2)
    function increment() {
      count.value++
    }
    return { count, doubleCount, increment }
  }),
}

export const getConfig = async () => {
  // 先从本地缓存获取
  const localConfig = sessionStorage.getItem('app_config')

  if (localConfig) {
    return JSON.parse(localConfig)
  }

  try {
    // 如果本地没有,请求 public/config.json
    const response = await fetch('/config.json')
    if (!response.ok) {
      throw new Error('Failed to fetch config.json')
    }

    const config = await response.json()

    // 写入本地缓存
    sessionStorage.setItem('app_config', JSON.stringify(config))

    return config
  } catch (error) {
    console.error('Error loading config:', error)
    return {} // 请求失败返回空对象
  }
}
